/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
export * from "./browser";



//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/core/dist/esm/compatibility/index.js
// module id = 884
// module chunks = 0